import React from 'react';

const LoadingLogo = () => {
    return (
        <div className="loading-wrapper">
            <img className="bouncing-logo" src="/logo192.png" alt="Loading..." />
        </div>
    );
};

export default LoadingLogo;
